/**
 * Smart dropdown positioning that detects viewport boundaries and positions optimally.
 */
export function getSmartDropdownPosition(
  buttonElement: HTMLButtonElement,
  dropdownWidth: number = 235,
  dropdownHeight: number = 200
) {
  if (!buttonElement) return { top: 0, left: 0, position: 'below' };

  const buttonRect = buttonElement.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const viewportWidth = window.innerWidth;

  const slideoutPanel = document.querySelector(
    '[data-testid="sliding-panel-modal"]'
  ) as HTMLElement;
  const panelRect = slideoutPanel?.getBoundingClientRect();

  const spaceBelow = viewportHeight - buttonRect.bottom;
  const spaceAbove = buttonRect.top;

  const panelSpaceBelow = panelRect
    ? panelRect.bottom - buttonRect.bottom
    : spaceBelow;
  const panelSpaceAbove = panelRect
    ? buttonRect.top - panelRect.top
    : spaceAbove;

  const showAbove =
    panelSpaceBelow < dropdownHeight + 20 &&
    panelSpaceAbove > dropdownHeight + 20;

  let top: number;
  let position: 'above' | 'below';

  if (showAbove) {
    top = buttonRect.top - dropdownHeight - 6;
    position = 'above';
  } else {
    top = buttonRect.bottom + 6;
    position = 'below';
  }

  let left = buttonRect.left;

  if (panelRect) {
    const panelMinLeft = panelRect.left + 10;
    const panelMaxLeft = panelRect.right - dropdownWidth - 10;

    if (left < panelMinLeft) {
      left = panelMinLeft;
    } else if (left + dropdownWidth > panelMaxLeft) {
      left = Math.max(panelMinLeft, buttonRect.right - dropdownWidth);
    }
  } else {
    const minLeft = 10;
    const maxLeft = viewportWidth - dropdownWidth - 10;

    if (left < minLeft) {
      left = minLeft;
    } else if (left + dropdownWidth > maxLeft) {
      left = Math.max(minLeft, buttonRect.right - dropdownWidth);
    }
  }

  if (panelRect) {
    const slideoutHeader = slideoutPanel?.querySelector(
      '[data-testid="slide-out-header"]'
    ) as HTMLElement;
    const headerHeight = slideoutHeader?.offsetHeight || 80;
    const headerBottom = panelRect.top + headerHeight;

    if (position === 'above') {
      const panelMinTop = headerBottom + 10;
      top = Math.max(panelMinTop, top);
    } else {
      const panelMaxTop = panelRect.bottom - dropdownHeight - 20;
      top = Math.min(panelMaxTop, top);
    }
  } else {
    if (position === 'above') {
      top = Math.max(20, top);
    } else {
      top = Math.min(viewportHeight - dropdownHeight - 20, top);
    }
  }

  return { top, left, position };
}
